import React from 'react';
import Modal from './Modal';

interface ModalErrorProps {
  isOpen: boolean,
  message: string,
  subMessage?: string,
  onClose: () => void,
};

const ModalError = ({
  isOpen,
  message,
  subMessage,
  onClose,
}: ModalErrorProps) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        isClosable={false}
        onClose={onClose}
        Content={(
          <>
            <span className='error-modal-message'>
              {message}
            </span>
            <span className='error-modal-sub-message'>
              {subMessage}
            </span>
            <button className='confirm-button h-40 mb-14' onClick={onClose}>
              확인
            </button>
          </>
        )}
      />
    </>
  );
};

export default ModalError;